import { loadComponent } from "./load-component";
import { loadScript, ScriptStatus } from "./load-script";

export async function importRemote(src: string, scope: string, module: string) {
  await new Promise<ScriptStatus>((resolve, reject) =>
    loadScript(src, (scriptStatus) => {
      if (scriptStatus === "ready") {
        resolve(scriptStatus);
      } else {
        reject(new Error(`Error when trying to load ${src}`));
      }
    })
  );

  return loadComponent(scope, module);
}
